/**
 * Public dev route — same UI as production YouTube analytics, wired to static
 * mock data (no login). Uses DemoLayout for the same chrome as /demo (background,
 * nav, theme). Open: /dev/youtube-analytics-mock
 */
import React from "react";
import { useDemoScrollToTop } from "../../hooks/useDemoScrollToTop";
import DemoLayout from "../demo-dashboard/DemoLayout";
import YoutubeAnalyticsMockContainer from "../project/youtube-analytics/YoutubeAnalyticsMockContainer";

export default function YoutubeAnalyticsMockPage() {
  useDemoScrollToTop([]);

  return (
    <DemoLayout backLink={{ to: "/demo", label: "← Demo dashboard" }}>
      <YoutubeAnalyticsMockContainer />
    </DemoLayout>
  );
}
